export const REDUCER_NAME = "pageSectionSlice";

export interface iTabDataResponse {
  id: string;
  content: string; // Adjust based on your actual data structure
  created_at: string;
  updated_at: string;
}

export interface iTabDataDTO {
  termsContent?: string;
  privacyContent?: string;
  refundContent?: string;
  returnContent?: string;
  cancellationContent?: string;
  aboutContent?: string;
  question?: string;
  answer?: string;
  status?: "active" | "inactive";
  ranking?: number;
  title?: string;
  image?: File | string;
}

export interface iPageSectionState {
  tabDetail: iTabDataResponse | null;
  tabList: iTabDataResponse[];
  isLoading: boolean;
  errorMessage: string | null;
}